import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { PraService } from "../services/pra.service";
import { AuthenticationService } from "../services/authentication.service";
import { FormatDataService } from "../services/format-data.service";
import { first } from "rxjs/operators";
import { Router, ActivatedRoute } from "@angular/router";
import { ngxLoadingAnimationTypes } from "ngx-loading";
import { GridOptions } from "ag-grid";
import { ChildRequestGridComponent } from "../pra-search-requests/child-request-grid/child-request-grid.component";
import { GridDataModel } from "../pra-search-requests/dataModel";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
//Format Time with momentJS
import * as moment from "moment";
//lodash
import * as _ from "lodash";

@Component({
  selector: "app-pra-search-requests",
  templateUrl: "./pra-search-requests.component.html",
  styleUrls: ["./pra-search-requests.component.css"],
  host: {
    "(document:click)": "onClick($event)",
  },
})
export class PraSearchRequestsComponent implements OnInit {
  //Datepicker
  model = {};
  @ViewChild("d1") datePicker;

  //Loading
  public loading = false;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  //Current User
  currentUser: any;
  opsId: any = null;

  //Lists
  regionList: any[];
  processLevelList: any[];
  storeList: any[];
  employeeList: any[];
  excelList: any[];
  statusList = [
    {
      name: "- - All - -",
      value: null,
    },
    {
      name: "Submitted",
      value: 2,
    },
    {
      name: "Completed",
      value: 5,
    },
    {
      name: "Cancelled",
      value: 3,
    },
  ];
  praRequestsList: any[];
  params: any;

  //Form Variables
  regionId: number;
  selectedRegion: number;
  selectedRegionIndex: number;
  selectedProcessLevel: string;
  selectedStore: any;
  selectedStoreIndex: number;
  selectedEmployee: number = null;
  selectedEmployeeName: string;
  selectedStatus: number;
  selectedStatusIndex: number;
  selectedStartDate: { year: number; month: number; day: number };
  selectedEndDate: { year: number; month: number; day: number };

  //Lists
  gridList: Array<GridDataModel> = new Array<GridDataModel>();

  //Track Index
  selectedEmployeeNameIndex: number;

  //Views
  selectOpsList: boolean = false;
  selectStoreView: boolean = false;

  //Flags
  validateStartDate: boolean = true;
  validateEndDate: boolean = true;
  showExcelButton: boolean = false;
  showEIDSearch: boolean = false;

  //Error handling variables
  consentErrMsg = "";

  // Get Today's Date Variables
  todayDate: any = moment().format("MM/DD/YYYY");

  //Grid
  private gridApi;
  private gridColumnApi;
  public gridOptions: GridOptions;
  private rowClassRules;

  // Track Grid Filter Events
  currentGridFilter: any;
  currentSortFilter: any;

  //Modals
  modalOption: NgbModalOptions = {};
  modalComplete: NgbModalRef;
  modalCompleteConfirm: NgbModalRef;
  closeResult: string;


  constructor(
    private PraService: PraService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private formatDataService: FormatDataService,
    private _eref: ElementRef,
    private modalService: NgbModal,
  ) {
    this.gridOptions = <GridOptions>{};
    this.gridOptions.columnDefs = this.requestHeaders();
    this.gridOptions.context = {
      componentParent: this,
    };
    this.gridOptions.getRowStyle = function (params) {
      if (params.data.RequestStatusCode == "Cancelled") {
        return { background: "#f8ea70" };
      }
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.params = params;
    });

    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));

    //Reset validation flags
    this.validateStartDate = false;
    this.validateEndDate = false;

    //Set EID search button flag;
    if (this.currentUser.payrolladmin == true) {
      this.showEIDSearch = true;
    } else if (this.currentUser.payrolladmin == false && this.currentUser.canRequestNew == false && this.currentUser.opsId == 0) {
      this.showEIDSearch = true;
    } else {
      this.showEIDSearch = false;
    }

    //Show region dropdown if user has an Ops List
    if (
      this.currentUser.opsList.length > 0 &&
      this.currentUser.opsList[0].OpsID != 0
    ) {
      //Set views
      this.selectOpsList = true;
      this.selectStoreView = true;

      //Get region list
      this.regionList = this.currentUser.opsList;
      console.log(this.regionList);

      //Get process level list
      this.processLevelList = this.currentUser.RegionList;
      console.log(this.processLevelList);

      //Add "All" in region dropdown, add "My Region" for Payroll Admins
      if (this.currentUser.payrolladmin == true) {
        this.regionList.unshift(
          {
            OpsID: null,
            OpsTitle: "- - My Region - -",
          },
          {
            OpsID: 0,
            OpsTitle: "- - All - -",
          }
        );
      } else {
        this.regionList.unshift({
          OpsID: null,
          OpsTitle: "- - All - -",
        });
      }

      //Add "All" in process level dropdown if it us not null
      if (this.processLevelList !== null) {
        this.processLevelList.unshift("- - All - -");
      }

      if (typeof this.params.ID !== "undefined") {
        //Set default region
        this.selectedRegion = this.regionList[
          parseInt(this.params.RegionIndex)
        ].OpsID;
        this.selectedRegionIndex = parseInt(this.params.RegionIndex);
        console.log(
          (this.selectedRegion = this.regionList[
            parseInt(this.params.RegionIndex)
          ].OpsID)
        );
        //Set default process level
        console.log(this.params.ProcessLevel);
        this.selectedProcessLevel = this.params.ProcessLevel;
      } else {
        //Set selected region
        if (this.currentUser.payrolladmin == true) {
          this.selectedRegion = this.regionList[0].OpsID;
          this.selectedRegionIndex = 0;
        } else {
          this.selectedRegion = this.regionList[0].OpsID;
          this.selectedRegionIndex = 0;
        }


        //Set selected process level
        this.selectedProcessLevel = "- - All - -";
      }
      console.log(this.selectedRegion);

      //Show full store list when selected region is NULL
      this.storeList = this.PraService.getStores();
      //Add "All" in storelistdropdown
    } else {
      this.storeList = this.currentUser.storeList;
    }

    console.log(this.storeList);

    //if store user has one store, do not add NULL option on storelist
    if (this.storeList.length != 1) {
      //Views
      this.selectStoreView = true;

      //Add "All" in storelistdropdown
      this.storeList.unshift({
        StoreID: null,
        StoreName: "- All - -",
      });
    }

    if (typeof this.params.ID !== "undefined") {
      if (isNaN(parseInt(this.params.Store))) {
        this.selectedStore = this.storeList[0].StoreID;
        this.selectedStoreIndex = 0;
      } else {
        this.selectedStore = this.storeList[
          parseInt(this.params.StoreIndex)
        ].StoreID;
        this.selectedStoreIndex = parseInt(this.params.StoreIndex);
      }
      if (isNaN(parseInt(this.params.Status))) {
        this.selectedStatus = this.statusList[0].value;
        this.selectedStatusIndex = 0;
      } else {
        console.log(parseInt(this.params.StatusIndex));
        this.selectedStatus = this.statusList[
          parseInt(this.params.StatusIndex)
        ].value;
        this.selectedStatusIndex = parseInt(this.params.StatusIndex);
      }
      this.selectedStartDate = {
        year: parseInt(this.params.StartDateYear),
        month: parseInt(this.params.StartDateMonth),
        day: parseInt(this.params.StartDateDay),
      };
      console.log({
        year: parseInt(this.params.StartDateYear),
        month: parseInt(this.params.StartDateMonth),
        day: parseInt(this.params.StartDateDay),
      });
      this.selectedEndDate = {
        year: parseInt(this.params.EndDateYear),
        month: parseInt(this.params.EndDateMonth),
        day: parseInt(this.params.EndDateDay),
      };
      console.log({
        year: parseInt(this.params.EndDateYear),
        month: parseInt(this.params.EndDateMonth),
        day: parseInt(this.params.EndDateDay),
      });
    } else {
      //Set default store
      this.selectedStore = this.storeList[0].StoreID;
      this.selectedStoreIndex = 0;

      //Set default status /Payroll admin default to "Submitted"
      if (this.currentUser.payrolladmin == true) {
        this.selectedStatus = this.statusList[1].value;
        this.selectedStatusIndex = 1;
      } else {
        this.selectedStatus = this.statusList[0].value;
        this.selectedStatusIndex = 0;
      }

      //Set default dates
      this.selectedStartDate = this.formatDataService.getStartDateForCalendar();
      console.log(this.selectedStartDate);
      this.selectedEndDate = this.formatDataService.getEndDateForCalendar();
      console.log(this.selectedEndDate);
    }

    if (this.selectedStore == null) {
      //Get PRA Reuests
      this.getPraRequests();
    } else {
      this.getEmployeeList();
    }
  }

  closeFix(event, datePicker) {
    if (event.target.offsetParent == null) datePicker.close();
    else if (event.target.offsetParent.nodeName != "NGB-DATEPICKER")
      datePicker.close();
  }

  selectRegion(evt) {
    this.selectedRegion = evt;
    console.log(this.selectedRegion);
    //Find Store Index
    let list = this.regionList.filter((i) => i.OpsID === evt)[0];
    console.log(list);
    this.selectedRegionIndex = this.regionList.indexOf(list);
    console.log(this.selectedRegionIndex);
    //clear process level
    this.selectedProcessLevel = "- - All - -";

    this.getStoreList();
    this.employeeList = [];
  }

  selectProcessLevel(evt) {
    this.selectedProcessLevel = evt;
    console.log(this.selectedProcessLevel);

    //clear region select
    if (this.currentUser.payrolladmin == true) {
      this.selectedRegionIndex = 1;
      this.selectedRegion = 0;
    } else if (this.currentUser.payrolladmin == false && this.currentUser.canRequestNew == false && this.currentUser.opsId == 0) {
      this.selectedRegionIndex = 0;
      this.selectedRegion = null;
    } else {
      this.selectedRegionIndex = 1;
      this.selectedRegion = 0;
    }


    this.selectedStoreIndex = 0;
    this.selectedStore = null;
    this.getStoreListPL();
    this.employeeList = [];
  }

  selectStore(evt) {
    this.selectedStore = evt;
    console.log(this.selectedStore);
    //Find Store Index
    let list = this.storeList.filter((i) => i.StoreID === evt)[0];
    console.log(list);
    this.selectedStoreIndex = this.storeList.indexOf(list);
    console.log(this.selectedStoreIndex);
    if (this.selectedStore == null) {
      this.selectedEmployee = undefined;
      this.selectedEmployeeName = undefined;
      this.employeeList = [];
      //Get PRA Reuests
      this.getPraRequests();
    } else {
      this.getEmployeeList();
    }
  }

  selectEmployee(evt) {
    console.log(this.selectedEmployee);
    this.selectedEmployee = evt;

    let list = this.employeeList.filter((i) => i.EmployeeID === evt)[0];
    this.selectedEmployeeName = list.DisplayName;
    this.selectedEmployeeNameIndex = this.employeeList.indexOf(list);
    console.log(this.selectedEmployeeName);
    console.log(this.selectedEmployeeNameIndex);
    this.getPraRequests();
  }

  selectStatus(evt) {
    this.selectedStatus = evt;
    console.log(this.selectedStatus);
    let list = this.statusList.filter((i) => i.value === evt)[0];
    console.log(list);
    this.selectedStatusIndex = this.statusList.indexOf(list);
    console.log(this.selectedStatusIndex);
    this.getPraRequests();
  }

  selectStartDate(evt) {
    this.selectedStartDate = evt;
    console.log(this.selectedStartDate);

    let startDate = this.formatDataService.formatDateForValidation(
      this.selectedStartDate
    );
    let endDate = this.formatDataService.formatDateForValidation(
      this.selectedEndDate
    );
    let dayDifference = moment(endDate).diff(moment(startDate), "days");
    console.log(moment(endDate).diff(moment(startDate), "days"));

    if (dayDifference < 0) {
      this.validateStartDate = true;
      this.validateEndDate = false;
    } else {
      this.validateEndDate = false;
      this.validateStartDate = false;
      //Get PRA Requests on calendar select
      this.getPraRequests();
    }
  }

  selectEndDate(evt) {
    this.selectedEndDate = evt;
    console.log(this.selectedEndDate);

    let startDate = this.formatDataService.formatDateForValidation(
      this.selectedStartDate
    );
    let endDate = this.formatDataService.formatDateForValidation(
      this.selectedEndDate
    );
    let dayDifference = moment(endDate).diff(moment(startDate), "days");
    console.log(moment(endDate).diff(moment(startDate), "days"));

    if (dayDifference < 0) {
      this.validateEndDate = true;
      this.validateStartDate = false;
    } else {
      this.validateEndDate = false;
      this.validateStartDate = false;
      //Get PRA Requests on calendar select
      this.getPraRequests();
    }
  }

  submitSearch() {
    this.getPraRequests();
  }

  //Track Grid Activities
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setFilterModel(this.currentGridFilter);
    this.gridApi.setSortModel(this.currentSortFilter);
    this.gridApi.onFilterChanged();
    console.log(this.currentGridFilter);
    console.log(this.currentSortFilter);
  }

  onSortChange() {
    console.log(this.gridApi.getSortModel());
    this.currentSortFilter = this.gridApi.getSortModel();
  }

  onFilterChange() {
    console.log(this.gridApi.getFilterModel());
    this.currentGridFilter = this.gridApi.getFilterModel();
  }

  //Grid headers
  private requestHeaders() {
    return [
      {
        headerName: "",
        field: "Value",
        width: 160,
        colId: "params",
        cellRendererFramework: ChildRequestGridComponent,
      },
      {
        headerName: "Date Created",
        field: "DateCreated",
        width: 115,
        colId: "params",
      },
      {
        headerName: "Selected Week",
        field: "SelectedWeek",
        width: 122,
        colId: "params",
      },
      {
        headerName: "Request ID",
        field: "PRARequestID",
        width: 100,
        colId: "params",
      },
      { headerName: "EID", field: "EmployeeID", width: 80, colId: "params" },
      {
        headerName: "Name",
        field: "EmployeeName",
        width: 132,
        colId: "params",
      },
      {
        headerName: "Status",
        field: "RequestStatusCode",
        width: 90,
        colId: "params",
      },
      {
        headerName: "Total Hours",
        field: "Total",
        width: 115,
        colId: "params",
      },
      {
        headerName: "Home Store",
        field: "HomeStore",
        width: 110,
        colId: "params",
      },
      {
        headerName: "Work Store",
        field: "WorkStoreID",
        width: 110,
        colId: "params",
      },
      { headerName: "Home State", field: "State", width: 110, colId: "params" },
      {
        headerName: "Process Level",
        field: "RegionCode",
        width: 115,
        colId: "params",
      },
      {
        headerName: "Comments",
        field: "Comments",
        width: 120,
        colId: "params",
      }
    ];
  }

  // Request List Details Button
  public methodFromParent(id) {
    console.log(id);
    this.router.navigate(["./view-adjustment-records/pra-details"], {
      queryParams: {
        ID: id,
        Region: this.selectedRegion,
        Store: this.selectedStore,
        EID: this.selectedEmployee,
        EmployeeName: this.selectedEmployeeName,
        EmployeeIndex: this.selectedEmployeeNameIndex,
        Status: this.selectedStatus,
        StartDateMonth: this.selectedStartDate.month,
        StartDateDay: this.selectedStartDate.day,
        StartDateYear: this.selectedStartDate.year,
        EndDateMonth: this.selectedEndDate.month,
        EndDateDay: this.selectedEndDate.day,
        EndDateYear: this.selectedEndDate.year,
        RegionIndex: this.selectedRegionIndex,
        StoreIndex: this.selectedStoreIndex,
        StatusIndex: this.selectedStatusIndex,
        ProcessLevel: this.selectedProcessLevel,
      },
    });
  }

  getStoreList() {
    //Get store list from chosen region
    if (this.selectedRegion == null || this.selectedRegion == 0) {
      //Show full store list when selected region is NULL
      this.storeList = this.PraService.getStores();
      //Add "All" in storelistdropdown
      this.storeList.unshift({
        StoreID: null,
        StoreName: "- All - -",
      });
      this.selectedStore = null;
      this.selectedEmployee = undefined;
      this.selectedEmployeeName = undefined;
      this.employeeList = [];
      this.getPraRequests();
    } else {
      this.storeList = this.currentUser.storeList.filter(
        (i) => i.OrgUnitID === this.selectedRegion
      );
      this.storeList.sort(function (a, b) {
        return a.StoreID - b.StoreID;
      });

      //Add "All" in storelistdropdown
      this.storeList.unshift({
        StoreID: null,
        StoreName: "- All - -",
      });

      console.log(this.storeList);
      //Set default store
      this.selectedStore = this.storeList[0].StoreID;
      this.getPraRequests();
    }
  }

  getStoreListPL() {
    //Get store list from chosen region
    if (this.selectedProcessLevel == "- - All - -") {
      //Show full store list when selected region is NULL
      this.storeList = this.PraService.getStores();
      //Add "All" in storelistdropdown
      this.storeList.unshift({
        StoreID: null,
        StoreName: "- All - -",
      });
      this.selectedStore = null;
      this.selectedEmployee = undefined;
      this.selectedEmployeeName = undefined;
      this.employeeList = [];
      this.getPraRequests();
    } else {
      let storeList = [];
      storeList = this.currentUser.storeList.filter(
        (i) => i.Region === this.selectedProcessLevel
      );
      // Filter to unique stores
      this.storeList = _.uniqBy(storeList, "StoreID");

      this.storeList.sort(function (a, b) {
        return a.StoreID - b.StoreID;
      });

      //Add "All" in storelistdropdown
      this.storeList.unshift({
        StoreID: null,
        StoreName: "- All - -",
      });

      console.log(this.storeList);
      //Set default store
      this.selectedStore = this.storeList[0].StoreID;
      this.getPraRequests();
    }
  }

  getEmployeeList() {
    this.loading = true;
    //Grab employee list based off current store or store selected
    this.PraService.getEmployeeListAndStore(this.selectedStore)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          data.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
          this.employeeList = data;

          //Add "All" in dropdown
          this.employeeList.unshift({
            EmployeeID: null,
            DisplayName: "- - All - -",
          });

          console.log(this.employeeList);

          if (typeof this.params.Store !== "undefined") {
            this.selectedEmployee = this.employeeList[
              parseInt(this.params.EmployeeIndex)
            ].EmployeeID;
            this.selectedEmployeeName = this.employeeList[
              parseInt(this.params.EmployeeIndex)
            ].DisplayName;
            this.selectedEmployeeNameIndex = parseInt(
              this.params.EmployeeIndex
            );
          } else {
            this.selectedEmployee = this.employeeList[0].EmployeeID;
            this.selectedEmployeeName = this.employeeList[0].DisplayName;
            this.selectedEmployeeNameIndex = 0;
          }

          //Get PRA Reuests
          this.getPraRequests();
        },
        (error) => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(["/login"]);
          } else {
            console.log("API ERROR:");
            console.log(error);
          }
        }
      );
  }

  getPraRequests() {
    let processLevel: string;
    if (this.selectedProcessLevel == "- - All - -") {
      processLevel = "";
    } else {
      processLevel = this.selectedProcessLevel;
    }
    console.log(processLevel);
    //Pass NULL if Ops ID is 0
    //if (this.currentUser.payrolladmin == true) {
    //this.opsId = 0;
    //}
    console.log(this.selectedEmployee);

    this.gridList = [];

    console.log(
      this.currentUser.userId +
      "; " +
      this.currentUser.employeeId +
      "; " +
      this.currentUser.payrolladmin +
      "; " +
      this.currentUser.opsLevel +
      "; " +
      this.selectedStatus +
      "; " +
      this.selectedRegion +
      "; " +
      this.selectedStartDate.month +
      "/" +
      this.selectedStartDate.day +
      "/" +
      this.selectedStartDate.year +
      "; " +
      this.selectedEndDate.month +
      "/" +
      this.selectedEndDate.day +
      "/" +
      this.selectedEndDate.year +
      "; " +
      this.selectedStore +
      "; " +
      this.selectedEmployee +
      "; " +
      processLevel
    );

    this.loading = true;
    const result = this.PraService.getPRARequests(
      this.currentUser.userId,
      this.currentUser.employeeId,
      this.currentUser.payrolladmin,
      this.currentUser.opsLevel,
      this.selectedStatus,
      this.selectedRegion,
      this.selectedStartDate.month +
      "/" +
      this.selectedStartDate.day +
      "/" +
      this.selectedStartDate.year,
      this.selectedEndDate.month +
      "/" +
      this.selectedEndDate.day +
      "/" +
      this.selectedEndDate.year,
      this.selectedStore,
      this.selectedEmployee,
      processLevel
    )
      .pipe(first())
      .subscribe(
        (data) => {
          console.log(data);
          this.loading = false;
          data.reverse();

          for (let index in data) {
            this.gridList.push(new GridDataModel(data[index]));
          }
          //Make a new list to remove Business Date and Daily Total
          let newList: any = []
          for (let index in this.gridList) {
            newList.push({
              DateCreated: this.gridList[index].DateCreated,
              SelectedWeek: this.gridList[index].SelectedWeek,
              PRARequestID: this.gridList[index].PRARequestID,
              EmployeeID: this.gridList[index].EmployeeID,
              EmployeeName: this.gridList[index].EmployeeName,
              RequestStatusCode: this.gridList[index].RequestStatusCode,
              Total: this.gridList[index].Total,
              HomeStore: this.gridList[index].HomeStore,
              WorkStoreID: this.gridList[index].WorkStoreID,
              State: this.gridList[index].State,
              RegionCode: this.gridList[index].RegionCode,
              Comments: this.gridList[index].Comments
            });
          }

          console.log(data);
          this.praRequestsList = _.uniqWith(newList, _.isEqual);
          this.excelList = this.gridList;
          console.log(this.gridList);

          //show Excel button of PRA list shows records
          if (this.praRequestsList.length > 0) {
            this.showExcelButton = true;
          }
        },
        (error) => {
          if (error.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(["/login"]);
          } else if (error.status === 500) {
            this.loading = false;
            this.praRequestsList = [];
          } else {
            this.consentErrMsg =
              "Something went wrong, please contact your administrator:" +
              error;
          }
        }
      );
  }

  exportAsXLSX() {
    //Create data model for excel sheet
    let excelList = [];
    for (let index in this.excelList) {
      excelList.push({
        DateCreated: this.excelList[index].DateCreated,
        SelectedWeek: this.excelList[index].SelectedWeek,
        RequestID: this.excelList[index].PRARequestID,
        EID: this.excelList[index].EmployeeID,
        Name: this.excelList[index].EmployeeName,
        Status: this.excelList[index].RequestStatusCode,
        BusinessDate: this.excelList[index].BusinessDate,
        DailyTotalHours: this.excelList[index].DailyTotalHours,
        TotalHours: this.excelList[index].Total,
        HomeStore: this.excelList[index].HomeStore,
        WorkStore: this.excelList[index].WorkStoreID,
        HomeState: this.excelList[index].State,
        ProcessLevel: this.excelList[index].RegionCode,
        Comments: this.excelList[index].Comments
      });
    }
    console.log(excelList);

    this.PraService.exportAsExcelFile(
      excelList,
      "PraList" + moment().format("YYYY-MM-DD")
    );
  }

  public activateLoading() {
    this.loading = true;
  }

  public completeMethodCompleted() {
    this.getPraRequests();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }



}
